import { Dialog, DialogTitle, DialogContent,Typography,  IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import navbar_background from '../assets/navbar_background.svg';



type Props = {
    open: boolean,
    onClose: (() => void)
}

function AboutOverpriceDialog({ open, onClose }: Props) {

    return (
        <>
            <Dialog
                open={open}
                keepMounted
                onClose={onClose}
                aria-describedby="alert-dialog-slide-description"
                fullWidth
                maxWidth='sm'

            >
                <DialogTitle color='white' sx={{ bgcolor: '#00617b', backgroundImage: `url(${navbar_background})`, backgroundSize: "cover" }}>
                    <Typography variant='h4'>Sobrepreço pré-calculado</Typography>
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            right: 15,
                            top: 15,
                        }}
                    >
                        <Close sx={{ color: "white" }} />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ m: 2, display: 'flex', flexDirection: 'column' }}>

                    <Typography variant="body1" color="initial">
                        O sistema Quanto Custa possui dados de compras públicas (Licitações, Contratos, Notas Fiscais e Empenho) e também fontes de preços de referência (ANP, CEASA-MG, Anvisa e o Site Consulta Remédios). Foi implementada uma funcionalidade que calcula previamente o sobrepreço de itens de compras públicas com base nos preços de referência.
                    </Typography>
                    <Typography variant="body1" color="initial" sx={{mt: 1}}>
                        O cruzamento dos dados de compras públicas com dados de referência é feito por uma combinação <i>fuzzy</i> das descrições dos itens. Essa é uma técnica que identifica textos que correspondem parcialmente, e não exatamente, a um outro texto. Além disso, foram utilizados no cruzamento de dados os campos: ano, mês, unidade de medida e município. Após o cruzamento, foram selecionados apenas os itens de compras públicas cujo valor é maior que o valor do preço de referência.
                    </Typography>

                </DialogContent>
            </Dialog>

        </>

    );
}
export default AboutOverpriceDialog;
